// Javelin location photo upload — POST /api/javelin/photoUpload.
// Request is multipart/form-data (home_id + photo file + optional thumb
// preview, 2026-07-25), parsed in the handler — no zod req schema
// (binary-style endpoint per contracts rule); this contract covers the
// success response only. Shape snapped from participants_ext.ts
// photoUpload (PR-74 port, 2026-06-11). photo_r2_key is versioned since
// 2026-07-25: homes/<home_id>_<ts>.jpg (+ sibling _thumb.jpg).
import { z } from 'zod';

export const JavPhotoUploadResSchema = z.object({
  ok: z.literal(true),
  photo_r2_key: z.string(),
});
export type JavPhotoUploadRes = z.infer<typeof JavPhotoUploadResSchema>;
